import { trackById } from 'src/app/shared/utils/track-by.util';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IOrganizationLevelDialogData, OrganizationLevelDialogComponent } from 'src/app/modals/organization-level-dialog/organization-level-dialog.component';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { DeleteDialog } from '../delete-dialog/delete-dialog.component';
import { OrganizationLevelService } from 'src/app/services/organizationLevel.service';

@Component({
  standalone: false,
  selector: 'app-hierarchy-node',
  templateUrl: './hierarchy-node.component.html',
  styleUrls: ['./hierarchy-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HierarchyNodeComponent {
  @Input() node!: OrganizationLevel;
  isActionMenuOpen = false;

  constructor(protected dialog: MatDialog,
    private organizationLevelService: OrganizationLevelService
  ) { }

  addOrganization(node: OrganizationLevel = null) {
    this.openOrganizationDialog({ id: '', parentId: node?.id })
  }

  editOrganization(node: OrganizationLevel) {
    this.openOrganizationDialog({ id: node.id, parentId: node.parentId })
  }

  public trackById = trackById;

  closeDialog(dialogRef) {
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.organizationLevelService.organizationsUpdated.next(true)
      }
    });
  }

  openOrganizationDialog(data: IOrganizationLevelDialogData) {
    const dialogRef = this.dialog.open(OrganizationLevelDialogComponent, {
      data: {
        ...data,
        isReadonly: false
      },
      width: '460px',
      disableClose: true,
      hasBackdrop: false,
      panelClass: 'comment-dialog-container'
    });
    this.closeDialog(dialogRef);
  }

  deleteOrganization(node: OrganizationLevel) {
    const dialogRef = this.dialog.open(DeleteDialog, {
      data: {
        id: node.id,
        formDeletes: true,
        service: this.organizationLevelService,
        title: 'Organization Level'
      },
      width: '440px',
      disableClose: true
    });

    this.closeDialog(dialogRef);
  }
}
